import { createContext } from 'react';

/**
 * Page-level actions available inside a settings panel. ClassroomDetail
 * provides this around the active page's panel so the shared
 * "Remove page" button (see RemovePageButton) can live in the panel
 * header next to each module's "Reset settings" without every page
 * module threading a removal handler through its props — they only
 * receive `classroom`.
 *
 * Kept in its own (component-free) module so the React Fast Refresh
 * boundary in pageActions.tsx stays a pure-component file.
 */
export interface PageActions {
  /** Human label for the page, used in the confirm dialog. */
  pageLabel: string;
  /**
   * Remove this page from the classroom (kept in the catalog to re-add).
   * Provided for Morning Meeting pages (add/remove flow); absent for the
   * permanent classroom pages, which use `toggle` instead.
   */
  onRemove?: () => void;
  /**
   * Enable/disable this page. Provided for the permanent classroom pages
   * (YouTube, Links); the control renders in the panel header.
   */
  toggle?: { enabled: boolean; onToggle: (next: boolean) => void };
}

export const PageActionsContext = createContext<PageActions | null>(null);
